module.exports = __webpack_public_path__ + "static/media/external_env_3_media_3.ef5374e5.webp";